import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Spinner, Alert } from "react-bootstrap";
import ItemSCore from "./ItemSCore";
import LoginAndUpdate from "./LoginAndUpdate";
import Register from "./item/register";
import Leaderboard from "./item/leaderboard";
import logo from "./dog.png";
import Squares from "./components/Squares";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import ViewScores from "./ViewScore";
import DateManager from "./DateManager";

function Home() {
  const [status, setStatus] = useState(null); // 状态：null, "loading", "success", "error"

  const handleUpdateItems = async () => {
    setStatus("loading"); // 设置为“更新中”
    try {
      const response = await fetch(
        "https://api.kero.zone/dogking/updateItem/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.ok) {
        setStatus("success"); // 设置为“更新成功”
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    } catch (error) {
      setStatus("error"); // 设置为“更新失败”
    } finally {
      // 定时器：5秒后将状态重置为 null
      setTimeout(() => setStatus(null), 3000);
    }
  };

  return (
    <div className="home-background">
      <Squares
        speed={0.5}
        squareSize={40}
        direction="diagonal"
        borderColor="rgba(255,255,255,0.25)"
        hoverFillColor="rgba(255,255,255,0.15)"
      />
      <div className="home-content">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <a className="App-link" href="/Update" rel="noopener noreferrer">
            报分
          </a>
          <button
            type="button"
            className="App-link app-link-btn"
            onClick={handleUpdateItems}
          >
            从GameWith获取最新数据
          </button>

          {status === "loading" && (
            <div className="mt-3">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          )}
          {status === "success" && (
            <Alert variant="success" className="mt-3">
              更新完毕！
            </Alert>
          )}
          {status === "error" && (
            <Alert variant="danger" className="mt-3">
              更新失败，请稍后再试。
            </Alert>
          )}
          <a
            className="App-link"
            href="/leaderborad"
            rel="noopener noreferrer"
          >
            总分排行榜
          </a>
        </header>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/item_score" element={<ItemSCore />} />
        <Route path="/Update" element={<LoginAndUpdate />} />
        <Route path="/register" element={<Register />} />
        <Route path="/leaderborad" element={<Leaderboard />} />
        <Route path="/view" element={<ViewScores />} />
        <Route path="/date" element={<DateManager />} />
      </Routes>
    </Router>
  );
}

export default App;
